import { render } from "./StageTable.vue?vue&type=template&id=605874ca&scoped=true&ts=true"
import script from "./StageTable.vue?vue&type=script&lang=ts"
export * from "./StageTable.vue?vue&type=script&lang=ts"

import "./StageTable.vue?vue&type=style&index=0&id=605874ca&scoped=true&lang=less"

import exportComponent from "E:\\operationmanualNew\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-605874ca"]])

export default __exports__